const value = {
    systemSpecificationsTitle: 'System specifications',
    systemSpecificationsDes:
      'List of sections and values the user can select in each section when filling out an system profile.',
    categories: 'Categories',
    categoriesOfSpecification: 'Categories',
    values: 'Values',
    valuesOfSpecification: 'Values of specification',
    requirementsExecutorTitle: 'Requirements Executor',
    requirementsExecutorDes:
      'The user selects this feature when creating an system profile to hide some fields or requirements from external developers.',
    executors: 'Executors',
    integrationsTitle: 'Integrations',
    integrationsDes: 'List of integrations with Active Directory, and the Mail  System.',
    integrationsDesASM: 'List of integrations with Active Directory',
    mail: 'Mail',
    loggingTitle: 'Logging',
    loggingDes: 'Contains event log.',
    eventLog: 'Event log',
    templatesTitle: 'Templates of profiles',
    templatesDes: 'List of profile  templates.',
    userManagementTitle: 'User  management',
    userManagementDes: 'List of  system users.',
    users: 'Users',
    projectRoles: 'Project roles',
    systemRoles: 'System roles',
  };

export default value;
